import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

const routes: Routes = [
    { path: '', loadChildren: () => import('./../app/pages/app-pages.module').then(m => m.AppPagesModule) },
    {
        path: 'error',
        loadChildren: () => import('./../app/pages/error/error.module').then(m => m.ErrorModule)
    },
    // Endereço que não existe no portal (sem isso a navegação falha e a tela fica em branco).
    { path: '**', redirectTo: 'error/404' }
]

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'enabled'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
